import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function RoadHaulage() {
  return (
    <>
      <SEO
        title="Road Haulage in Holland & Belgium | Fastlane ApS"
        description="Normal transit time for transport of goods between Holland / Belgium and Denmark is 48 to 96 hours. Fastlane provides road haulage and multimodal connections."
        canonicalUrl="https://fastlane.dk/road-haulage-Holland-Belgium"
      />

      <PageHeader
        title="Road Haulage in Holland & Belgium"
        subtitle="Normal transit time for transport of goods between Holland / Belgium and Denmark is 48 to 96 hours."
        breadcrumbs={[
          { label: 'Services', path: '/godstransport-i-europa' },
          { label: 'Holland & Belgium' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="p-4 bg-sky-50 border border-sky-200 text-sky-950 font-semibold rounded-xl text-base sm:text-lg">
            Normal transit time for transport of goods between Holland / Belgium and Denmark is 48 to 96 hours.
          </div>

          {/* Types of transport */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-[#0f2b48]">We offer the following types of transport:</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-slate-700">
              {[
                'Palletized goods',
                'Packages / boxes',
                'Groupage / Consolidated goods',
                'Part loads',
                'Full loads',
                'Dedicated truck',
                'Loose trailer systems',
                'Driver accompanied transport',
                'Courier transports',
                'Transport of heavy goods',
                'Transport of long goods',
                'Project transport',
                'Transport of exhibition goods',
                'Transport of art',
                'Multimodal transport'
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-2.5 p-3 rounded-lg bg-slate-50 border border-slate-200">
                  <i className="fa-solid fa-circle-check text-sky-600 text-xs shrink-0" aria-hidden="true" />
                  <span className="font-medium text-slate-900">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Transportation equipment */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-[#0f2b48]">Via our supplier base we have access to all types of commonly known transportation equipment:</h2>
            <ul className="space-y-2 text-sm sm:text-base text-slate-700">
              {[
                'Curtain-sided trailer (tilt trailer or tautliner)',
                'Boxtrailer',
                'Palletwide container',
                'Temperature regulated trailer',
                'Low loader',
                'Megatrailer',
                'Huckapack trailer',
                'Trailer with Moffert truck',
                'Trucks with crane'
              ].map((eq, idx) => (
                <li key={idx} className="flex items-start gap-2">
                  <i className="fa-solid fa-angle-right text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                  <span>{eq}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Geographical coverage */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4 border-t border-slate-200">
            <div className="p-6 bg-slate-50 rounded-2xl border border-slate-200">
              <h3 className="text-base font-bold text-[#0f2b48] mb-2">We cover all Denmark – below the 5 biggest cities:</h3>
              <p className="text-sm text-slate-700 font-medium">Copenhagen, Aarhus, Odense, Aalborg and Esbjerg</p>
            </div>
            <div className="p-6 bg-slate-50 rounded-2xl border border-slate-200">
              <h3 className="text-base font-bold text-[#0f2b48] mb-2">We cover all Holland / Belgium for example the below cities:</h3>
              <p className="text-sm text-slate-700 font-medium">Antwerpen, Bruxelles, Maastricht, Amsterdam, Rotterdam, Venlo, and Utrecht</p>
            </div>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-between border-t border-slate-200">
            <span className="text-sm text-slate-600">To obtain freight rates please contact us:</span>
            <Link
              to="/fragtrater"
              className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#b25d19] text-white text-sm font-semibold hover:bg-[#974d12] text-center"
            >
              Send Enquiry
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
